import { render } from "./Support.vue?vue&type=template&id=792258b6"
import script from "./Support.vue?vue&type=script&setup=true&lang=js"
export * from "./Support.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Support.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "792258b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('792258b6', __exports__)) {
    api.reload('792258b6', __exports__)
  }
  
  module.hot.accept("./Support.vue?vue&type=template&id=792258b6", () => {
    api.rerender('792258b6', render)
  })

}


export default __exports__